<template>
  <div class="question-mian">
    <div class="question-cnt">
      <div class="ques-top">
        <div class="t_999 t_center">第 2 步 (共 3 步)</div>
        <div class="ques-title">请进入商品详情页浏览商品后，回答下方问题，验证所找的商品是否正确。</div>
        <div class="ques-tip">答题Tips：<span class="t_blue" @click="whereSampleImg">商品主图在哪里？</span></div>
      </div>
      <div class="ques-box">
        <div class="ques-box-title">（1/3）以下图片中，哪一张是商品主图板块的第{{ questionInfo.Position }}张图片？</div>
        <div class="ques-box-select">
          <div
            v-for="(item, index) in questionInfo.ItemList"
            :key="index"
            :class="{
              'ques-select-square': true,
              active: currentActive === index,
              error: currentErr === index
            }"
            @click="selectItemClick(index)"
          >
            <div class="ques-select-radio">{{ index | filterSelectText }}</div>
            <div class="ques-select-img answersImg"><img v-lazy="item.Url" alt="" /></div>
          </div>
        </div>
        <div class="ques-box-error" v-show="errTipShow"><span class="iconfont icon-guanbi"></span>很遗憾，回答错误！等待 {{ minErrTime }}s 后再重新选择~</div>
      </div>
    </div>
    <div class="question-btn">
      <div class="question-btn-btn shCancelBtn" @click="goBack">上一步</div>
      <div :class="['question-btn-btn shPrimaryBtn', btnDisabled ? 'disable' : 'sure']" @click="next">{{ btnText }}</div>
    </div>
    <preview-dialog v-if="previewDialogShow" @close="previewDialogShow = false" :img-src="previewImgSrc"> </preview-dialog>
  </div>
</template>

<script>
import CountDownMinx from '@/views/purchaseProcess/quesAndAnswers/minxCountDown'
import { IMG_BASE_URL } from '@/config'
import PreviewDialog from '@/components/puppetComponent/PreviewDialog'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { ProductVerifyQuestion1, ProductVerifyAnswer1 } from '@/api/question'
export default {
  name: 'QuestionOne',
  mixins: [CountDownMinx],
  data() {
    return {
      isLoading: false,
      errTipShow: false,
      currentActive: null,
      currentErr: null,
      questionInfo: {},
      previewImgSrc: '',
      previewDialogShow: false,
      sampleImg: IMG_BASE_URL + '/upaiyun/Sys/20200107/4648251827211612944.jpg',
      minErrTime: 15
    }
  },
  mounted() {
    this.taskId = this.$route.query.taskID
    if (this.taskId) {
      this.fetchData()
    } else {
      Toast('无任务id')
      this.$router.go(-1)
    }
  },
  components: {
    PreviewDialog
  },
  methods: {
    fetchData() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      ProductVerifyQuestion1({ taskId: this.taskId })
        .then((res) => {
          Indicator.close()
          this.questionInfo = res.Data
          if (this.questionInfo.CountDownSecond) {
            // 倒计时开始
            this.startCountDown(parseInt(this.questionInfo.CountDownSecond))
          }
        })
        .catch((err) => {
          Indicator.close()
          if (err.ErrMsg === '无法生成题目') {
            this.$router.replace({
              name: 'jdQuestionTwo',
              query: {
                taskID: this.taskId
              }
            })
          } else if (err.ErrMsg === '任务不是待搜索的') {
            this.taskTimeOutShow()
          } else {
            Toast(err.ErrMsg)
          }
        })
    },
    // 任务超时显示
    taskTimeOutShow() {
      MessageBox({
        title: '提示',
        message: '当前订单已过期，请重新选择商品~',
        showCancelButton: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        confirmButtonText: '我知道了',
        confirmButtonClass: 't_f23030'
      }).then((action) => {
        if (action === 'confirm') {
          this.$router.replace({ name: 'souhuo' })
        }
      })
    },
    // 条目选择
    selectItemClick(index) {
      this.currentErr = null
      this.errTipShow = false
      this.currentActive = index
    },
    countDownEnd() {
      this.errTipShow = false
      this.currentActive = null
      this.currentErr = null
      document.scrollingElement.scrollTop = 0
    },
    // 提示示例图
    whereSampleImg() {
      this.previewDialogShow = true
      this.previewImgSrc = this.sampleImg
    },
    goBack() {
      this.$router.go(-1)
    },
    next() {
      if (this.btnDisabled) return
      if (this.isLoading) return
      if (this.currentActive === null) {
        Toast('请选择商品主图')
        return
      }
      if (!this.taskId) return
      this.errTipShow = false
      this.isLoading = true
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      ProductVerifyAnswer1({
        taskId: this.taskId,
        itemImgId: this.questionInfo.ItemList[this.currentActive].ItemImgID
      })
        .then((res) => {
          Indicator.close()
          this.$router.replace({
            name: 'jdQuestionTwo',
            query: {
              taskID: this.taskId
            }
          })
        })
        .catch((err) => {
          this.isLoading = false
          Indicator.close()
          this.submitErrHandler(err)
        })
    },
    submitErrHandler(err) {
      this.currentErr = this.currentActive
      if (err.ErrMsg === '回答错误') {
        this.errTipShow = true
        this.minErrTime = err.Data.CountDownSecond
        this.startCountDown(parseInt(this.minErrTime))
        this.$nextTick(() => {
          document.scrollingElement.scrollTop = document.scrollingElement.scrollHeight
        })
      } else if (err.ErrMsg === '进入淘口令模式') {
        let errData = err.Data
        MessageBox({
          title: '提示',
          message: '很遗憾，又回答错误了~请返回上一步，核实搜索商品是否正确。若无误，请点击验证商品链接进行验证',
          showCancelButton: true,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          cancelButtonText: '上一步',
          confirmButtonText: '验证商品链接',
          confirmButtonClass: 't_f23030'
        }).then((action) => {
          if (action === 'confirm') {
            // 进入淘口令验证
            this.$router.replace({
              name: 'pddStepTwo',
              query: {
                productId: errData.ProductID,
                keywordID: errData.KeywordID,
                isFreeCard: errData.isFreeCard
              }
            })
          } else {
            this.$router.go(-1)
          }
        })
      } else if (err.ErrMsg === '任务不是待搜索的') {
        this.taskTimeOutShow()
      } else {
        Toast(err.ErrMsg)
      }
    }
  }
}
</script>

<style scoped>
@import '../../../quesAndAnswers/question.css';
</style>
